import React from 'react';
import { createRoutesFromReactChildren } from 'react-router/lib/RouteUtils';

// We are using React Router 3, and it is hacky to create custom Route!
// We can use standard React component structure once we are at Router >= 4
// https://marmelab.com/blog/2016/09/20/custom-react-router-component.html
function createCustomRoute(componentName, defineRoute) {
  function CustomRoute() {
    return <div />;
  }

  CustomRoute.displayName = componentName;

  CustomRoute.createRouteFromReactElement = (element, parentRoute) => {
    const route = createRoutesFromReactChildren(
      defineRoute(element.props),
      parentRoute
    )[0];
    return route;
  };

  return CustomRoute;
}

export default createCustomRoute;
